// extracted by css-extract-rspack-plugin
export default {"error":"Show__error--afr79","noteWrap":"Show__noteWrap--fIePN"};